import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationRequisitionPage } from '@/features/marketPromotion/pages/DonationRequisitionPage';
import { donationRequisitionSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/requisitions')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.REQUISITION_VIEW),
  validateSearch: donationRequisitionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Donation Requisition">
      <Suspense fallback={<PageLoader />}>
        <DonationRequisitionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
